(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anju-stock-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.anjuStockProp) return;
    window.anjuStockProp = true;
    const NAME = 'properties[Delivery]';
    const VALUE = 'Made to order, 4–6 weeks';
    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
        const id = form.querySelector('[name="id"]')?.value;
        const mto = id && document.querySelector(`[data-anju-mto-ids*=",${id},"]`);
        let input = form.querySelector(`input[name="${NAME}"]`);
        if (mto) {
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = NAME;
            form.appendChild(input);
          }
          input.value = VALUE;
        } else if (input) {
          input.remove();
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
